export enum Workflow {
  Transfer = 1,
  Other = 0
}
